import React from 'react';
import HomeTemplate from '../../Templates/HomeTemplate';

const homePage = props => <HomeTemplate />

export default homePage;